export default __webpack_public_path__ + "static/assets/ef6f7b4d2d47fd31245a12852d9080a2.svg";